import client from "@/api/client/axios";
import type { ResponseConfig } from "@/api/client/axios";
import type { GetTenderBannerInfoQueryResponse, GetTenderBannerInfoQueryParams } from "../../types/GetTenderBannerInfo";

/**
     * @link /api/purchase-tenders/private/v1/tender/view_banner
     */
export async function getTenderBannerInfo (params?: GetTenderBannerInfoQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): Promise<ResponseConfig<GetTenderBannerInfoQueryResponse>["data"]> {
    const { data: resData } = await client<GetTenderBannerInfoQueryResponse>({
        method: "get",
        url: `/api/purchase-tenders/private/v1/tender/view_banner`,
        params,
        ...options
    });
    
    return resData;
};